import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var HelpCircle = createReactComponent("HelpCircle", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["path", {
  d: "M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3",
  key: "2vwi0r"
}], ["line", {
  x1: "12",
  y1: "17",
  x2: "12.01",
  y2: "17",
  key: "1fwdlo"
}]]]);
export default HelpCircle;